module.exports = "https://static.wmbcdn.com/uniweb/images/999bf1dbcf1c2337cb7d42bc18b5f079.svg";